module.exports = __webpack_public_path__ + "img/processing.b870f743.png";